import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

// pickupdrop - Get All (Read)
export const GetAll = createAsyncThunk(
  "ServiceAdmin/pickupdrop/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${
          APIS.ServiceAdmin.PickupDropOrders
        }?c_vehicle_no=${filter?.c_vehicle_no ||
          ""}&adviser_name=${filter?.adviser_name ||
          ""}&adviser_no=${filter?.adviser_no ||
          ""}&uniq_id=${filter?.uniq_id || ""}&vehcile_no=${filter?.vehicleNo ||
          ""}&service_type_id=${filter?.service_type_id ||
          ""}&pickup_drop_status_id=${filter?.pickup_drop_status_id ||
          ""}&to=${filter?.to || ""}&from=${filter?.from ||
          ""}&todayFilter=${filter?.todayFilter ||
          ""}&ongoing=${filter?.ongoing || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// pickupdrop - Get (Read)
export const GetSingle = createAsyncThunk(
  "ServiceAdmin/pickupdrop/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.ServiceAdmin.PickupDropOrders}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// pickupdrop - Create (Add)
export const Create = createAsyncThunk(
  "ServiceAdmin/pickupdrop/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.ServiceAdmin.PickupDropOrders, data);
      return res; // The new pickupdrop object
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// pickupdrop - Update
export const Update = createAsyncThunk(
  "ServiceAdmin/pickupdrop/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(
        `${APIS.ServiceAdmin.PickupDropOrders}/${id}`,
        data
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// pickupdrop - Delete
export const Delete = createAsyncThunk(
  "ServiceAdmin/pickupdrop/delete",
  async (id, { rejectWithValue }) => {
    try {
      const data = await DELETE(`${APIS.ServiceAdmin.PickupDropOrders}/${id}`);
      return id; // Return the id of the deleted pickupdrop
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// pickupdrop - Status
export const Status = createAsyncThunk(
  "ServiceAdmin/pickupdrop/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.ServiceAdmin.PickupDropOrders}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const canceltrip = createAsyncThunk(
  "ServiceAdmin/pickupdrop/cancel-trip",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await POST(
        `${APIS.ServiceAdmin.PickupDropOrders}/cancel-trip/${id}`,
        { cancel_reason: data }
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "pickupdrop",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(Create.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload.data;
      })

      .addCase(canceltrip.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(canceltrip.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload;
        // const index = state.data.findIndex(
        //   (category) => category.id === action.payload?.data?.id
        // );
        // if (index !== -1) {
        //   state.data[index] = action.payload.data;
        // }
      })
      .addCase(canceltrip.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Update.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        const index = state.data.findIndex(
          (country) => country.id === action.payload?.data?.id
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(Update.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (country) => country.id !== action.payload.id
        ); // Remove the country with the deleted id
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      //
      .addCase(Status.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Status.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (country) => country.id !== action.payload.id
        ); // Remove the country with the deleted id
      })
      .addCase(Status.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
